module.exports = {
    debugMode: true,
    server: {
        api: {
            baseUrl: process.env.REACT_APP_API_BASEURL || 'https://api.yogiq.app/api/',
            biometricMatrixApi: process.env.REACT_APP_BIOMETRIC_MATRIX_API || 'https://biometricmatrix-dev.yogiq.app/biometricmatrix/',
            paymentsApi: process.env.REACT_APP_PAYMENTS_API || 'https://payments-dev.yogiq.app/payment/',
            progressApi: process.env.REACT_APP_PROGRESS_API || 'https://progress-dev.yogiq.app/progress/',
            questionApi: process.env.REACT_APP_QUESTION_API || 'https://questions-dev.yogiq.app/question/',
            sessionApi: process.env.REACT_APP_SESSIONS_API || 'https://sessions-dev.yogiq.app/session/',
            securityApi: process.env.REACT_APP_SECURITY_API || 'https://security-dev.yogiq.app/security/',
            schoolApi: process.env.REACT_APP_SCHOOL_API || 'https://school-dev.yogiq.app/school/',
            statsApi: process.env.REACT_APP_STATS_API || 'https://stats-dev.yogiq.app/stat/',
            timeout: 20000,
            headTimeout: 2000
        }
    }
};